const informasiList = [{
  TechnicianName: 'John',
  StartDate: 'Jun-23-2023',
  
  },
  

];

  export {informasiList}